"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _default = (0, _createReactClass.default)({
  displayName: "CompositionNotFound",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    backLink: _propTypes.default.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      backLink: 'https://app.hubspot.com'
    };
  },
  render: function render() {
    return _react.default.createElement(_UIErrorMessage.default, {
      className: "no-composition",
      type: "notFound"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.global.notFound"
    }), _react.default.createElement("div", {
      className: "m-top-4"
    }, _react.default.createElement(_UILink.default, {
      href: this.props.backLink
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.global.goBackToDashboard"
    }))));
  }
});

exports.default = _default;
module.exports = exports.default;